module.exports = __webpack_public_path__ + "static/img/pd_detail_4.e5ce4fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footerpic/footerDetailPic/pd_detail_4.jpg
// module id = gfm2
// module chunks = 52